let swRegistration = null;
let reloadPending = false;

export function register() {
  if ('serviceWorker' in navigator) {
    // Don't wait for window load on modern browsers
    const registerSW = () => {
      navigator.serviceWorker
        .register('service-worker.js', { scope: '/' })
        .then((registration) => {
          console.log('SW registered: ', registration);
          swRegistration = registration;

          // Health check for service worker
          const healthCheck = () => {
            if (!navigator.serviceWorker.controller) {
              console.warn('Service Worker lost control, attempting re-registration');
              registration.unregister().then(() => {
                setTimeout(registerSW, 1000);
              });
            }
          };

          // Check every 30 seconds
          setInterval(healthCheck, 30000);

          // Check if service worker is controlling the page
          if (navigator.serviceWorker.controller) {
            console.log('Service Worker is controlling the page');
          } else {
            console.log('Service Worker registered but not controlling the page');
          }

          // Listen for controller changes. This fires on the very first time
          // a SW takes control of an already-open page too (not just on
          // updates), so only reload when the user explicitly triggered an
          // update via applyUpdate() - never prompt or reload on our own.
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('Service Worker controller changed - page now controlled by SW');

            if (reloadPending) {
              reloadPending = false;
              window.location.reload();
            }
          });

          // Listen for service worker updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('New Service Worker found:', newWorker?.state);
            
            newWorker.addEventListener('statechange', () => {
              console.log('Service Worker state changed:', newWorker.state);
              
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New content available, please refresh.');
              }
            });
          });

          // Check for updates
          registration.update();
          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
          // Retry registration after delay
          setTimeout(registerSW, 5000);
        });
    };

    if (document.readyState === 'loading') {
      window.addEventListener('load', registerSW);
    } else {
      registerSW();
    }

    // Global error handling
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SERVICE_WORKER_CONSOLE_LOG') {
        console.log(`[SW ${event.data.logType}]: ${event.data.message}`);
      }
    });

    navigator.serviceWorker.addEventListener('messageerror', (event) => {
      console.error('Message error from Service Worker:', event);
    });
  }
}

const UPDATE_POLL_INTERVAL_MS = 300;
const UPDATE_POLL_MAX_ATTEMPTS = 10;

// Triggered only by an explicit user action (the "Update Now" button in
// Settings). Forces a fresh check against the deployed service-worker.js,
// activates it once it's ready, and reloads the page - never called on our
// own initiative.
export function applyUpdate() {
  if (!('serviceWorker' in navigator) || !swRegistration) {
    window.location.reload();
    return;
  }

  const activateWaitingWorker = (worker) => {
    if (!worker) {
      window.location.reload();
      return;
    }
    reloadPending = true;
    worker.postMessage({ type: 'SKIP_WAITING' });
  };

  swRegistration.update().finally(() => {
    if (swRegistration.waiting) {
      activateWaitingWorker(swRegistration.waiting);
      return;
    }

    let attempts = 0;
    const poll = setInterval(() => {
      attempts += 1;
      if (swRegistration.waiting) {
        clearInterval(poll);
        activateWaitingWorker(swRegistration.waiting);
      } else if (attempts >= UPDATE_POLL_MAX_ATTEMPTS) {
        clearInterval(poll);
        // No new SW showed up (e.g. only static content changed); a plain
        // reload still picks up fresh content via the network-first fetch
        // strategy and CRA's content-hashed asset filenames.
        window.location.reload();
      }
    }, UPDATE_POLL_INTERVAL_MS);
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}